import { useEffect } from 'react'
import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

export function usePushNotifications() {
  const { token } = useAuthStore()

  useEffect(() => {
    // Solo intentamos suscribir cuando hay token (usuario autenticado)
    if (!token) {
      return
    }

    if (typeof window === 'undefined') return

    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.warn('[Push] Browser does not support Web Push API')
      return
    }

    const vapidPublicKey = import.meta.env.VITE_VAPID_PUBLIC_KEY
    if (!vapidPublicKey || vapidPublicKey === 'your_vapid_public_key') {
      if (import.meta.env.DEV) {
        console.info('[Push] VITE_VAPID_PUBLIC_KEY not configured - push notifications disabled')
      }
      return
    }

    const subscribe = async () => {
      try {
        let permission = Notification.permission
        if (permission === 'default') {
          permission = await Notification.requestPermission()
        }

        if (permission !== 'granted') {
          console.warn('[Push] Notification permission not granted:', permission)
          return
        }

        const reg = await navigator.serviceWorker.ready
        let subscription = await reg.pushManager.getSubscription()

        if (!subscription) {
          const appServerKey = urlBase64ToUint8Array(vapidPublicKey)
          subscription = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: appServerKey as unknown as BufferSource,
          })
        }

        // Enviar suscripción al backend (usa api para reutilizar auth/tenant headers)
        await api.post('/api/subscribe', subscription)
        console.log('[Push] Subscription saved successfully')
      } catch (error) {
        console.error('[Push] Error during subscription', error)
      }
    }

    // Ejecutar en background sin bloquear render
    subscribe()
  }, [token])
}
